import { render, staticRenderFns } from "./DynamicForm.vue?vue&type=template&id=2b27ec8b&scoped=true"
import script from "./DynamicForm.vue?vue&type=script&lang=ts"
export * from "./DynamicForm.vue?vue&type=script&lang=ts"
import style0 from "./DynamicForm.vue?vue&type=style&index=0&id=2b27ec8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27ec8b",
  null
  
)

export default component.exports